<template>
  <div v-if="entityDrivingStyleDatas">
    <b-row v-if="type === 'ORGANISATION'">
      <b-col cols="6" >
        <driving-style-card title="Drive distance" :data="this.totalsPerEntity" :tab-props="dsConfigurations" />
      </b-col>
      <b-col cols="6" >
        <driving-style-card title="Total score" type="DRIVER" :data="this.entityScores" :tab-props="scoreConfigurations" />
      </b-col>
    </b-row>
    <b-row v-if="type === 'ASSET'">
      <b-col cols="6" >
        <driving-style-card title="Drive distance" type="DRIVER" :data="this.entityDrivingStyleDatas" :tab-props="dsConfigurations" />
      </b-col>
      <b-col cols="6" >
        <driving-style-card title="Total score" type="DRIVER" :data="this.entityScores" :tab-props="scoreConfigurations" />
      </b-col>
    </b-row>
    <b-row v-if="type === 'DRIVER'">
      <b-col cols="6" >
        <driving-style-card title="Drive distance" :data="this.entityDrivingStyleDatas" :tab-props="dsConfigurations" />
      </b-col>
      <b-col cols="6" >
        <driving-style-card title="Total score" :data="this.entityScores" :tab-props="scoreConfigurations" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Tabs from "../../components/Tabs/Tabs";
import TabPane from "../../components/Tabs/Tab";
import StatsCard from './StatsCard';
import ScoreCard from "./ScoreCard";
import DrivingStyleCard from "./DrivingStyleCard";
import TripCard from "./TripCard";
import {Option, Select} from "element-ui";
import crudApi from "../../crud/crud-api";
import moment from "moment";

export default {
  name: "driving-style-stats",
  props: {
    type: {
      type: String,
      required: true,
      default: 'ORGANISATION',
      description: "Types : ORGANISATION, ASSET, DRIVER"
    },
    ids: {
      type: Array,
      description: "ID array to query, can be asset ID's or driver ID's depending on the type"
    },
  },
  components: {
    Tabs,
    TabPane,
    StatsCard,
    ScoreCard,
    DrivingStyleCard,
    TripCard,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data: _ => ({
    drivingStyleData: {},
    totalsPerEntity: [],
    entityScores: [],
    entityDrivingStyleDatas: [],
    dsConfigurations: [
      {
        title: "Drive distance",
        valueProperty: "drivingDistance",
        formatValue: "distance",
      },
      {
        title: "Drive time",
        valueProperty: "drivingTime",
        formatValue: "duration",
      },
      {
        title: "Engine time",
        valueProperty: "engineTime",
        formatValue: "duration",
      },
      {
        title: "Idle time",
        valueProperty: "idleTime",
        formatValue: "duration",
        sortDesc:false,
      },
      {
        title: "PTO time",
        valueProperty: "ptoTime",
        formatValue: "duration",
      },
      {
        title: "Coast time",
        valueProperty: "coastTime",
        formatValue: "duration",
      },
      {
        title: "Acceleration time",
        valueProperty: "accelerationTime",
        formatValue: "duration",
      },
      {
        title: "Deceleration time",
        valueProperty: "decelerationTime",
        formatValue: "duration",
      },
      {
        title: "Cruise time",
        valueProperty: "cruiseTime",
        formatValue: "duration",
      },
      {
        title: "Engine brake time",
        valueProperty: "engineBrakeTime",
        formatValue: "duration",
      },
      {
        title: "Retarder time",
        valueProperty: "retarderTime",
        formatValue: "duration",
      },
      {
        title: "Over idle time",
        valueProperty: "idleThresholdTime",
        formatValue: "duration",
        sortDesc:false,
      },
      {
        title: "Over speed time",
        valueProperty: "overSpeedThresholdTime",
        formatValue: "duration",
        sortDesc:false,
      },
      {
        title: "Over RPM time",
        valueProperty: "overRPMThresholdTime",
        formatValue: "duration",
        sortDesc:false,
      },
      {
        title: "Over torque time",
        valueProperty: "overTorqueThresholdTime",
        formatValue: "duration",
        sortDesc:false,
      },
      {
        title: "Stops",
        valueProperty: "stops",
        sortDesc:false,
      },
      {
        title: "Brakes",
        valueProperty: "brakeUsages",
        sortDesc:false,
      },
      {
        title: "Harsh accelerations",
        valueProperty: "harshAccelerationThresholdTime",
        sortDesc:false,
      },
      {
        title: "Harsh brakes",
        valueProperty: "harshBrakes",
        sortDesc:false,
      },
      {
        title: "Harsh pedal",
        valueProperty: "harshAccelerationPedal",
        sortDesc:false,
      },
      {
        title: "Average speed",
        valueProperty: "averageSpeedDriving",
        unit: "km/h",
        decimal: 2,
      },
      {
        title: "Fuel avg. driving",
        valueProperty: "fuelAverageDriving",
        unit: "km/l",
        decimal: 2,
      },
      {
        title: "Fuel driving",
        valueProperty: "fuelUsedDriving",
        unit: "l",
        decimal: 2,
        sortDesc:false,
      },
      {
        title: "Fuel idle",
        valueProperty: "fuelUsedIdle",
        unit: "l",
        decimal: 2,
        sortDesc:false,
      },
      {
        title: "Fuel PTO",
        valueProperty: "fuelUsedPTO",
        unit: "l",
        decimal: 2,
        sortDesc:false,
      },
      {
        title: "Fuel Total",
        valueProperty: "fuelUsedTotal",
        unit: "l",
        decimal: 2,
        sortDesc:false,
      },
    ],
    scoreConfigurations: [
      {
        title: "Total",
        valueProperty: "total",
        decimal: 1
      },
      {
        title: "Idle",
        valueProperty: "idle",
        decimal: 1
      },
      {
        title: "Cruise",
        valueProperty: "cruise",
        decimal: 1
      },
      {
        title: "Coast",
        valueProperty: "coast",
        decimal: 1
      },
      {
        title: "Speed",
        valueProperty: "speed",
        decimal: 1
      },
      {
        title: "RPM",
        valueProperty: "rpm",
        decimal: 1
      },
      {
        title: "Acceleration",
        valueProperty: "harshAccleration",
        decimal: 1
      },
      {
        title: "Brake",
        valueProperty: "harshBrake",
        decimal: 1
      },
    ]
  }),
  created() {
    this.getReportData()
  },
  computed: {
    loadDrivingStyleData() {
      this.getReportData()

      return true
    },
    loadConfigurationGroups() {
      this.getGroups()

      return true
    },
  },
  watch: {
    '$store.state.filter.update': function () {
      this.refreshData()
    },
    drivingStyleData: function (newValue) {
      let properties = ['drivingDistance','drivingTime','idleTime','coastTime','cruiseTime','idleThresholdTime','overSpeedThresholdTime','overRPMThresholdTime','overTorqueThresholdTime','engineTime','ptoTime','harshAccelerationThresholdTime','harshBrakes','fuelUsedTotal','fuelUsedDriving','fuelUsedIdle','fuelUsedPTO','accelerationTime','decelerationTime','engineBrakeTime','retarderTime','stops','brakeUsages','harshAccelerationPedal']

      if (this.type === 'ORGANISATION') { // optimisation
        this.totalsPerEntity = this.getTotalsPerEntity(properties)
      } else { // optimisation
        this.entityDrivingStyleDatas = this.getEntityDrivingStyleDatas(properties)
      }
      this.entityScores = this.getEntityScores()
    }
  },
  methods: {
    refreshData() {
      this.getReportData()
    },
    getReportData() {
      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      let groups = ['ALL']
      if (this.$store.state.filter.group) {
        groups = [this.$store.state.filter.group]
      }

      console.log("Get driving style stats from => " + fromTime + " ; until => " + untilTime)

      if (this.type === 'ORGANISATION' || this.type === 'ASSET') {
        crudApi.getAllVehicleDrivingStyleData(this.$store.state.auth.user.organisation_id, fromTime, untilTime, this.ids, groups, false).then(json => this.drivingStyleData = json.data ? json.data : json);
      } else {
        crudApi.getAllDriverDrivingStyleData(this.$store.state.auth.user.organisation_id, fromTime, untilTime, this.ids, groups, false).then(json => this.drivingStyleData = json.data ? json.data : json);
      }
    },
    getPeriodData(intervalData) {
      if (intervalData.assetPeriodData) {
        return intervalData.assetPeriodData
      } else {
        return intervalData.driverPeriodData
      }
    },
    getEntityData(periodData) {
      if (periodData.assetData) {
        return periodData.assetData
      } else {
        return periodData.driverData
      }
    },
    getGroups() {
      crudApi.getGroups(this.$store.state.auth.user.organisation_id).then(json => this.groups = json.data ? json.data : json)
    },
    getEntityScores() {
      let driverScores = []

      if (!this.hasDrivingStyleData(this.drivingStyleData)) {
        return driverScores;
      }

      for (let intervalData of this.drivingStyleData.intervalData) {
        for (let entityPeriodData of this.getPeriodData(intervalData)) {
          for (let entityData of this.getEntityData(entityPeriodData)) {
            let id = entityData.assetId ? entityData.assetId : entityData.driverId
            let name = entityData.assetName ? entityData.assetName : entityData.driverName

            let driverScore = this.getDriverScoreFromDriverId(id, driverScores)
            if (id === 'UNKNOWN') {
              continue
            }

            if (entityData.drivingStyleData && (!entityData.drivingStyleData.drivingDistance || entityData.drivingStyleData.drivingDistance < 500)) {
              continue
            }

            let created = false

            if (driverScore === undefined) {
              driverScore = {
                id: id,
                name: name,
                count: 0,
                get total() {
                  return this.totalScore / this.count
                },
                get coast() {
                  return this.coastScore / this.count
                },
                get cruise() {
                  return this.cruiseScore / this.count
                },
                get harshAccleration() {
                  return this.harshAccelerationScore / this.count
                },
                get harshBrake() {
                  return this.harshBrakeScore / this.count
                },
                get idle() {
                  return this.idleScore / this.count
                },
                get rpm() {
                  return this.rpmScore / this.count
                },
                get speed() {
                  return this.speedScore / this.count
                }
              };
              created = true
            }
            for (let score in entityData.scoreData) {
              if (driverScore[score] === undefined) {
                driverScore[score] = 0
              }
              driverScore[score] += entityData.scoreData[score]
            }
            driverScore.count += 1

            if (created) {
              driverScores.push(driverScore)
            }
          }
        }
      }
      return driverScores
    },
    getDriverScoreFromDriverId(driverId, datas) {
      for (let data of datas) {
        if (data.id === driverId) {
          return data
        }
      }
    },
    getEntityDrivingStyleDatas(properties) {
      let uniqueDrivers = []

      if (!this.hasDrivingStyleData(this.drivingStyleData)) {
        return uniqueDrivers;
      }

      for (let intervalData of this.drivingStyleData.intervalData) {
        for (let entityPeriodData of this.getPeriodData(intervalData)) {
          for (let entityData of this.getEntityData(entityPeriodData)) {
            let id = entityData.assetId ? entityData.assetId : entityData.driverId
            let name = entityData.assetName ? entityData.assetName : entityData.driverName

            let driver = this.getDriverScoreFromDriverId(id, uniqueDrivers)

            if (driver === undefined) {
              driver = {
                id: id,
                name: name
              }

              this.updateDrivingStyleObject(entityData.drivingStyleData, driver, properties)

              uniqueDrivers.push(driver)
            }
          }
        }
      }

      return uniqueDrivers
    },
    getTotalsPerEntity(properties) {
      let assetTotals = []

      if (!this.hasDrivingStyleData(this.drivingStyleData)) {
        return assetTotals;
      }

      for (let intervalData of this.drivingStyleData.intervalData) {
        for (let entityPeriodData of this.getPeriodData(intervalData)) {
          let id = entityPeriodData.assetId ? entityPeriodData.assetId : entityPeriodData.driverId
          let name = entityPeriodData.assetName ? entityPeriodData.assetName : entityPeriodData.driverName

          let assetTotal = {
            id: id,
            name: name
          };

          for (let entityData of this.getEntityData(entityPeriodData)) {
            this.updateDrivingStyleObject(entityData.drivingStyleData, assetTotal, properties)
          }

          if (assetTotal.drivingDistance > 100) {
            assetTotals.push(assetTotal)
          }
        }
      }
      return assetTotals;
    },
    hasDrivingStyleData(drivingStyleData) {
      return drivingStyleData.intervalData && (drivingStyleData.intervalData[0].assetPeriodData || drivingStyleData.intervalData[0].driverPeriodData)
    },
    updateDrivingStyleObject(source, target, properties) {
      if (!source) {
        return
      }

      if (properties !== undefined) {
        for (let property of properties) {
          if (target[property] === undefined) {
            target[property] = 0
          }

          if (source[property] !== undefined && source[property] > 0) {
            target[property] += source[property];
          }
        }
      } else {
        for (let property in source) {
          if (target[property] === undefined) {
            target[property] = 0
          }

          if (source[property] !== undefined && source[property] > 0) {
            target[property] += source[property];
          }
        }
      }
      if (target.fuelUsedTotal && target.drivingDistance) {
        target['fuelAverageDriving'] = (target.drivingDistance/1000) / target.fuelUsedTotal;
      }
      if (target.drivingDistance && target.drivingTime) {
        target['averageSpeedDriving'] = this.$checkValue(target.drivingDistance) / (this.$checkValue(target.drivingTime) / 3600) / 1000
      }
    }
  }
}
</script>

<style scoped>

</style>
